import { Action } from "@ngrx/store";
import { DirectOnboardingConfig } from "../../services/uwl/uwl.service";

// Load DirectOnboardingConfigs
export const LOAD_DIRECT_ONBOARDING_CONFIGS = "[DirectOnboarding] Load DirectOnboardingConfigs";
export const LOAD_DIRECT_ONBOARDING_CONFIGS_SUCCESS =
  "[DirectOnboarding] Load DirectOnboardingConfigs Success";
export const LOAD_DIRECT_ONBOARDING_CONFIGS_FAIL =
  "[DirectOnboarding] Load DirectOnboardingConfigs Fail";

export class LoadDirectOnboardingConfigs implements Action {
  readonly type = LOAD_DIRECT_ONBOARDING_CONFIGS;
}

export class LoadDirectOnboardingConfigsSuccess implements Action {
  readonly type = LOAD_DIRECT_ONBOARDING_CONFIGS_SUCCESS;
  constructor(public payload: DirectOnboardingConfig[]) {}
}

export class LoadDirectOnboardingConfigsFail implements Action {
  readonly type = LOAD_DIRECT_ONBOARDING_CONFIGS_FAIL;
  constructor(public payload: any) {}
}

// Create DirectOnboardingConfig
export const CREATE_DIRECT_ONBOARDING_CONFIG =
  "[DirectOnboarding] Create DirectOnboardingConfig";
export const CREATE_DIRECT_ONBOARDING_CONFIG_SUCCESS =
  "[DirectOnboarding] Create DirectOnboardingConfig Success";
export const CREATE_DIRECT_ONBOARDING_CONFIG_FAIL =
  "[DirectOnboarding] Create DirectOnboardingConfig Fail";

export class CreateDirectOnboardingConfig implements Action {
  readonly type = CREATE_DIRECT_ONBOARDING_CONFIG;
  constructor(public payload: DirectOnboardingConfig) {}
}

export class CreateDirectOnboardingConfigSuccess implements Action {
  readonly type = CREATE_DIRECT_ONBOARDING_CONFIG_SUCCESS;
  constructor(public payload: DirectOnboardingConfig) {}
}

export class CreateDirectOnboardingConfigFail implements Action {
  readonly type = CREATE_DIRECT_ONBOARDING_CONFIG_FAIL;
  constructor(public payload: any) {}
}

// Update DirectOnboardingConfig
export const UPDATE_DIRECT_ONBOARDING_CONFIG =
  "[DirectOnboarding] Update DirectOnboardingConfig";
export const UPDATE_DIRECT_ONBOARDING_CONFIG_SUCCESS =
  "[DirectOnboarding] Update DirectOnboardingConfig Success";
export const UPDATE_DIRECT_ONBOARDING_CONFIG_FAIL =
  "[DirectOnboarding] Update DirectOnboardingConfig Fail";

export class UpdateDirectOnboardingConfig implements Action {
  readonly type = UPDATE_DIRECT_ONBOARDING_CONFIG;
  constructor(public payload: DirectOnboardingConfig) {}
}

export class UpdateDirectOnboardingConfigSuccess implements Action {
  readonly type = UPDATE_DIRECT_ONBOARDING_CONFIG_SUCCESS;
  constructor(public payload: DirectOnboardingConfig) {}
}

export class UpdateDirectOnboardingConfigFail implements Action {
  readonly type = UPDATE_DIRECT_ONBOARDING_CONFIG_FAIL;
  constructor(public payload: any) {}
}

// Delete DirectOnboardingConfig
export const DELETE_DIRECT_ONBOARDING_CONFIG =
  "[DirectOnboarding] Delete DirectOnboardingConfig";
export const DELETE_DIRECT_ONBOARDING_CONFIG_SUCCESS =
  "[DirectOnboarding] Delete DirectOnboardingConfig Success";
export const DELETE_DIRECT_ONBOARDING_CONFIG_FAIL =
  "[DirectOnboarding] Delete DirectOnboardingConfig Fail";

export class DeleteDirectOnboardingConfig implements Action {
  readonly type = DELETE_DIRECT_ONBOARDING_CONFIG;
  constructor(public payload: DirectOnboardingConfig) {}
}

export class DeleteDirectOnboardingConfigSuccess implements Action {
  readonly type = DELETE_DIRECT_ONBOARDING_CONFIG_SUCCESS;
  constructor(public payload: DirectOnboardingConfig) {}
}

export class DeleteDirectOnboardingConfigFail implements Action {
  readonly type = DELETE_DIRECT_ONBOARDING_CONFIG_FAIL;
  constructor(public payload: any) {}
}

export type DirectOnboardingActions =
  | LoadDirectOnboardingConfigs
  | LoadDirectOnboardingConfigsSuccess
  | LoadDirectOnboardingConfigsFail
  | CreateDirectOnboardingConfig
  | CreateDirectOnboardingConfigSuccess
  | CreateDirectOnboardingConfigFail
  | UpdateDirectOnboardingConfig
  | UpdateDirectOnboardingConfigSuccess
  | UpdateDirectOnboardingConfigFail
  | DeleteDirectOnboardingConfig
  | DeleteDirectOnboardingConfigSuccess
  | DeleteDirectOnboardingConfigFail;
